export interface ITabsSection {
  key: string
  title: string
  icon?: string
}
